var _style, _path, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgBancogalicia1 = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF6600;}\r\n\t.st1{fill-rule:evenodd;clip-rule:evenodd;fill:#FFFFFF;}\r\n\t.st2{fill-rule:evenodd;clip-rule:evenodd;fill:#EF945A;}\r\n\t.st3{fill-rule:evenodd;clip-rule:evenodd;fill:#CE4A63;}\r\n\t.st4{fill-rule:evenodd;clip-rule:evenodd;fill:#AD2931;}\r\n\t.st5{fill-rule:evenodd;clip-rule:evenodd;fill:#FF6600;}\r\n\t.st6{fill-rule:evenodd;clip-rule:evenodd;fill:#F7CEB5;}\r\n\t.st7{fill-rule:evenodd;clip-rule:evenodd;fill:#EFAD84;}\r\n\t.st8{fill-rule:evenodd;clip-rule:evenodd;fill:#EFAD7B;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M430.8,500H69.6c-38.3,0-69.4-31.1-69.4-69.4V69.4C0.2,31.1,31.3,0,69.6,0h361.2c38.3,0,69.4,31.1,69.4,69.4 v361.2C500.2,468.9,469.1,500,430.8,500z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "g3935"
  }, /*#__PURE__*/React.createElement("path", {
    id: "_160380112",
    className: "st1",
    d: "M21.5,312.1c0-41.4,0-82.8,0-124.2c152.3,0,304.7,0,457,0c0,41.4,0,82.8,0,124.2 C326.2,312.1,173.8,312.1,21.5,312.1L21.5,312.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160380232",
    className: "st2",
    d: "M108.6,307.2c121.5,0,243,0,364.5,0.1c0,0.1-0.1,0.2-0.1,0.3c-121.6-0.1-243.1-0.1-364.7-0.2 C108.4,307.3,108.5,307.3,108.6,307.2L108.6,307.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160380328",
    className: "st3",
    d: "M26.9,307.4C26.9,307.4,26.9,307.4,26.9,307.4c19.6,0,39.3,0,58.9,0 C66.1,307.4,46.5,307.4,26.9,307.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160380064",
    className: "st3",
    d: "M26.9,193.3C26.9,193.3,26.9,193.3,26.9,193.3c0,38.1,0,76.1,0,114.1c0,0,0,0,0,0 c-0.1,0-0.1,0-0.2,0c0-38.1,0-76.1,0-114.1C26.7,193.3,26.8,193.3,26.9,193.3L26.9,193.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160931448",
    className: "st4",
    d: "M85.8,307.4c-19.7,0-39.3,0-58.9,0c0-38,0-76,0-114c19.6,0,39.3-0.1,58.9-0.1 c2,0.1,4.1,0.3,6.1,0.4c0.2,0.2,2.6,0.4,2.7,0.6c11.1,2.1,20.2,7.3,28.7,14.5c4.1,4.2,7.4,8.5,10.6,13.6c1.1,2.4,2.3,4.7,3.4,7.1 c1.6,5.2,2.8,10,3.6,15.3c0,2.8,0.1,5.7,0.2,8.6c-0.3,2.2-0.5,4.4-0.7,6.6c-1.8,8.6-4.8,15.9-9.6,23.2c-2.4,3.1-2.4,3.1-2.6,3.5 c-6.3,6.7-12.4,11.5-20.5,15.7c-2,0.7-4,1.5-6,2.3C96.6,306.2,91.2,307.2,85.8,307.4L85.8,307.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160931544",
    className: "st5",
    d: "M108.6,307.2c7.5-3.3,14-7.6,20.2-13.1c0.3-0.4,2.4-2.4,6.1-6.7c3.3-4.7,6.3-9.3,8.8-14.5 c0.7-2,1.5-4,2.3-6c4.2-14.2,4-27.9-0.4-42.1c-0.7-1.9-1.5-3.8-2.2-5.6c-4.2-8.2-9.2-15.1-15.9-21.5c-1.7-1.5-3.4-2.9-5.1-4.3 c116.8,0,233.7-0.1,350.6-0.1c0,0,0.1,0.1,0.2,0.1c0,37.9,0,75.9,0,113.9C351.6,307.3,230.1,307.2,108.6,307.2L108.6,307.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160931640",
    className: "st1",
    d: "M83.8,295.4c-2.4-16.8-5.1-33.8-7-50.6c2.7-1.3,3.4-4.2,4.2-6.9c0.5-2.9,1.3-6.1,1.1-9.1 c-5.1,0.1-10.7,0.6-15.3,2.9c-5.7,0-6.1-8.1-0.1-8.6c5.1,2,10.2,2.7,15.7,2.9c-0.3-5.4-0.8-10.4-2.8-15.4c0-1.5,0.3-2.3,1.3-3.3 c3.4-2.2,6.7-0.8,7.3,3.3c-2.1,5.1-2.4,9.8-2.8,15.3c0.1,0,0.2,0.1,0.3,0.2c5.2-0.3,10.5-0.7,15.4-2.9c5.9,0.6,5.6,8.6-0.2,8.6 c-4.6-2.3-10.3-2.7-15.4-2.8c0.3,3.2,0.7,14.8,5.6,16c-0.3,2.6-0.4,2.7-5.4,39.9C85.3,284.9,83.9,295.1,83.8,295.4L83.8,295.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160931712",
    className: "st1",
    d: "M355.9,285.6c-7.5-0.7-12.4-3.3-16.7-9.7c-0.6-1.3-1.2-2.7-1.8-4c-4-15.6,3.6-31.6,20.4-33.5 c4.7,0,9.1,1.1,13.5,2.6c-0.1,0.6-0.1,0.6-2.7,7.4c-1.3-0.1-1.3-0.1-4.2-0.7c-1.7,0-3.3,0-5,0c-3.5,0.9-5.8,1.9-8.3,4.5 c-4.8,7-5.6,16.6,1.7,22.2c0.9,0.4,1.8,0.9,2.8,1.3c4.4,0.6,8.6,0.3,12.8-1c0.9-0.4,0.9-0.4,1.2-0.4c0.9,1.7,2.5,3.9,2.9,5.8 C367.3,283.2,362,285,355.9,285.6L355.9,285.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160931784",
    className: "st1",
    d: "M223.1,230.2c-1.2,0-2.3,0-3.4,0c-7.7,0-13.9,4.4-18.2,10.4c-1.3,2.7-1.9,4.6-2.1,4.8 c-1.5,6.2-1.1,11.9,0.9,17.9c3,5.8,6.4,8.9,12.4,11.2c1.3,0.2,2.6,0.5,3.9,0.7c2.7,0,7.1,0.3,9.4-0.8c0-4.8,0-9.6,0.1-14.4 c0-0.1,0-0.1-11-0.3c0-3,0-6.1,0-9.1c0,0,0-0.1,0-0.1c7.4,0,14.8,0,22.2,0c0,10.2,0,20.3,0.1,30.6c-2.1,0.7-4.3,1.5-6.4,2.2 c-3.7,0.9-7.1,1.7-10.9,2.1c-5.2,0.2-9.6-0.3-14.6-1.7c-9.6-4-15.3-10.8-18.2-20.7c-1.5-7.9-1.5-14.5,0.9-22.3 c1.5-3.8,3.6-7,6.1-10.3c4.6-4.6,9.1-6.9,15.3-9.1c8.9-1.9,17.5-0.9,26.2,1.5c-1,2.9-2,5.8-3,8.7 C226.8,230.5,226.8,230.5,223.1,230.2L223.1,230.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160943568",
    className: "st1",
    d: "M265.4,238.6c-5.5,0.2-10.9,2.3-16.4,4.5c0.8,2.2,1.7,4.4,2.5,6.6c2.4-0.8,4.8-1.5,7.2-2.3 c2.6-0.6,5.7-0.8,8.3-0.3c4.2,1.8,4.4,5.1,4.5,9.3c-7.6,0.5-14.7,0.6-21.2,4.9c-1.3,1.4-2.8,2.7-3.8,4.4c-1.4,3.7-1.2,6.9-0.4,10.6 c2.1,4.5,4.4,6.8,9,8.6c6.7,1.2,11.4-1.4,16.3-5.9c0.1,0,0.2,0.1,0.3,0.1c0.7,4.6,0.9,4.8,0.9,5c3.2,0,6.4,0,9.7,0.1 c0-10.9-0.1-21.7-0.1-32.6c-0.9-4.9-2.4-8.2-6.5-11.1C272.1,239,268.7,238.5,265.4,238.6z M271.5,263.6c0,2.7,0.1,5.5,0.1,8.2 c-1.9,3.3-6.9,4.8-10.4,5.2c-2.4-0.7-4.1-1.4-5.2-3.8C254.5,264.2,265.2,263.8,271.5,263.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160943640",
    className: "st1",
    d: "M418.4,238.5c-5.3,0.6-10.4,2.4-15.2,4.7c-0.3,1,1.7,5.3,2.5,6.7c4.8-1.8,8.9-3,14.1-3 c0.2,0.2,0.2,0.2,1.9,0.5c3.8,2,3.7,5.1,4.1,9.1c-9.3,0.6-21.8,0.5-25.7,11c-1.8,8.8,2.6,16.5,11.7,17.9c5.6,0,9.9-2.5,13.7-6.4 c0.1,0,0.3-0.1,0.4-0.1c0.6,4.5,0.6,4.5,0.9,5.4c3.1,0,6.3-0.1,9.5-0.1c0-10.3,0-20.5,0-30.7c-0.6-6.2-2.1-9.9-7.4-13.4 c-2.9-1.2-4.2-1.3-4.4-1.5C422.5,238.7,420.4,238.6,418.4,238.5z M425.6,263.5c0,2.8,0,5.7,0.1,8.6c-3.8,3.2-11.1,7.8-15.1,2.1 C406.5,265,419.5,263.7,425.6,263.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160943712",
    className: "st2",
    d: "M316.6,284.4c3.6,0,7.2-0.1,10.9-0.1C326.9,285,318,284.4,316.6,284.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160943808",
    className: "st2",
    d: "M426.8,284.4c3.1,0,6.3-0.1,9.4-0.1c0,0,0.1,0,0.1,0c-0.1,0-0.3,0.1-0.4,0.2 C432.9,284.5,429.8,284.4,426.8,284.4L426.8,284.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160943784",
    className: "st2",
    d: "M272.5,284.3c3.2,0,6.4,0,9.7,0.1C272.4,284.4,272.4,284.4,272.5,284.3z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160943952",
    className: "st2",
    d: "M293.3,216.5c0,22.6,0,45.2,0.1,67.9c3.7,0,7.4,0,11.2,0c-3.8,0-7.6,0-11.5,0 C293.1,261.7,293.2,239.1,293.3,216.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160943928",
    className: "st2",
    d: "M381,284.4c3.7,0,7.4,0,11.2,0C381,284.5,381,284.5,381,284.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160201728",
    className: "st2",
    d: "M316.3,239.6c0,14.9,0,29.9,0,44.8C316.2,284.4,316.2,284.4,316.3,239.6z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160201800",
    className: "st1",
    d: "M316.3,284.4c0-14.9,0-29.9,0-44.8c0,0,0.1,0,0.2,0c3.6,0,7.2,0,10.9,0 c0,14.9,0.1,29.8,0.1,44.7c-3.6,0-7.3,0-10.9,0.1C316.5,284.4,316.4,284.4,316.3,284.4L316.3,284.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160201896",
    className: "st1",
    d: "M293.3,216.5c0-0.1,0-0.2,0-0.3c3.7,0,7.5,0,11.2,0c0,22.7,0,45.4,0,68.1c-3.7,0-7.5,0-11.2,0 C293.3,261.7,293.3,239.1,293.3,216.5L293.3,216.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160201968",
    className: "st1",
    d: "M381,284.4c0-14.9,0-29.8,0-44.6c3.6,0,7.3-0.1,11-0.1c0,14.9,0.1,29.8,0.1,44.7 C388.4,284.4,384.7,284.4,381,284.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160202040",
    className: "st6",
    d: "M436.2,284.4c0-10.3,0-20.5,0-30.7c0,10.2,0,20.4,0.1,30.7 C436.3,284.4,436.3,284.4,436.2,284.4L436.2,284.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160202136",
    className: "st6",
    d: "M237.3,281c0-10.2-0.1-20.4-0.1-30.6c0,0,0-0.1,0.1-0.1C237.3,260.6,237.3,270.8,237.3,281z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160208248",
    className: "st7",
    d: "M425.7,272.1c0-2.9-0.1-5.7-0.1-8.6c0,0,0.1,0,0.2,0.1C425.8,266.5,425.7,269.3,425.7,272.1 L425.7,272.1z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160208344",
    className: "st8",
    d: "M214.9,259.7c0,0,0.1,0,0.1,0c11,0.2,11,0.2,11,0.3c-3.7,0-7.4,0-11.1,0 C215,259.8,214.9,259.8,214.9,259.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160208440",
    className: "st6",
    d: "M214.9,259.7c0-3,0-6.1,0.1-9.1c0,3,0,6.1,0,9.1C215,259.7,215,259.7,214.9,259.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160208512",
    className: "st7",
    d: "M215,250.5c0-0.1,0-0.1,22.3-0.1c0,0-0.1,0-0.1,0.1C229.8,250.5,222.4,250.5,215,250.5z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160201872",
    className: "st6",
    d: "M381,239.7c0-0.1,0-0.1,11-0.1C388.3,239.6,384.7,239.7,381,239.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160211680",
    className: "st1",
    d: "M321.6,229.7c-5.7-0.7-7.1-6.8-3.6-10.7c5.6-3.5,11,0.8,9.4,7.1 C325.9,228.5,324.3,229.5,321.6,229.7L321.6,229.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160211752",
    className: "st1",
    d: "M386.2,229.7c-4.8-0.9-6.9-5-4.6-9.6c2.7-3.1,7-3.4,9.8-0.1c2.1,4.2,0.8,7.9-3.5,9.5 C387.3,229.6,386.8,229.6,386.2,229.7z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160211824",
    className: "st7",
    d: "M293.3,216.2c0-0.1,0.1-0.2,0.2-0.3c3.6,0,7.3,0,10.9,0c0,0.1,0.1,0.2,0.2,0.3 C300.7,216.2,297,216.2,293.3,216.2L293.3,216.2z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160211896",
    className: "st3",
    d: "M26.9,193.4C26.9,193.3,26.9,193.3,26.9,193.4c19.6-0.1,39.3-0.1,58.9-0.1 C66.1,193.3,46.5,193.3,26.9,193.4z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "_160211656",
    className: "st2",
    d: "M122.3,193.4c0-0.1,0-0.1,350.6-0.1C356.1,193.3,239.2,193.3,122.3,193.4L122.3,193.4z"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgBancogalicia1);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/BANCOGALICIA1.85426f219accfb473e6235655622544c.svg";